/* eslint-disable no-param-reassign */
import React from 'react'

import NumberFormat from 'react-number-format'
import styled, { css } from 'styled-components'

import { InputProps } from '@customTypes'
import { MaskGuard } from '@customTypes/components/_helpers'
import { noop } from '_helpers/functions'

import { FormInput } from '../FormInput'
import { masks } from '../helpers'

const StyledInput = styled(FormInput)<InputProps>`
  ${({ buttonStyle }) => buttonStyle && css`
    cursor: pointer;
    caret-color: transparent;
  `}

  ${({ float }) => float && css`
  &::placeholder {
    color: transparent;
  }`}
`

export const InnerInput: React.FC<InputProps & MaskGuard> = React.forwardRef<
  HTMLInputElement,
  Omit<InputProps, 'ref'> & MaskGuard
>((props, ref) => {
  const { mask, onChangeValue, format, type, onKeyDown = noop, keyFilter, ...inputProps } = props

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = e => {
    if (keyFilter && (Array.isArray(keyFilter) ? keyFilter.includes(e.key) : e.key.match(keyFilter))) {
      e.stopPropagation()
      e.preventDefault()

      return
    }

    onKeyDown(e)
  }

  if (!mask && !format) {
    return <StyledInput {...inputProps} type={type} onKeyDown={handleKeyDown} ref={ref} />
  }

  const maskString = format || masks[mask as keyof typeof masks]

  const onValueChange = (values: { formattedValue: string; value: string }) => {
    if (onChangeValue) onChangeValue(values.formattedValue)
  }

  const getInputRef = (el: HTMLInputElement) => {
    if (ref && typeof ref !== 'function') { ref.current = el }
  }

  return (
    <NumberFormat
      {...inputProps}
      onKeyDown={handleKeyDown}
      type={type}
      format={maskString}
      customInput={StyledInput}
      onValueChange={onValueChange}
      getInputRef={getInputRef}
    />
  )
})

InnerInput.displayName = 'InnerInput'
